module.exports = __webpack_public_path__ + "img/13.0157e227.png";